module.exports = __webpack_public_path__ + "static/media/popupConfirm.9ff30b62.svg";